import { render, staticRenderFns } from "./ApprovedApplication.vue?vue&type=template&id=b8f0224e&"
import script from "./ApprovedApplication.vue?vue&type=script&lang=js&"
export * from "./ApprovedApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports